import React, { useState } from "react";
import PropTypes from "prop-types";

const Form = (props) => {
  const [blogDetails, setBlogDetails] = useState({
    title: "",
    blog: "",
    author: "",
  });
  const handleChange = (e) => {
    const selecedField = e.target.name;
    const selecedValue = e.target.value;
    setBlogDetails((prevState) => {
      return { ...prevState, [selecedField]: selecedValue };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(blogDetails);
    props.addBlogs(blogDetails);
    setBlogDetails({
      title: "",
      blog: "",
      author: "",
    });
  };
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="title">Blog Title</label>
        <input
          type="text"
          name="title"
          value={blogDetails.title}
          onChange={handleChange}
          required
          className="border-2 border-rose-600"
        ></input>
        <label htmlFor="title">Blog </label>
        <input
          type="text"
          name="blog"
          value={blogDetails.blog}
          onChange={handleChange}
          required
          className="border-2 border-rose-600"
        ></input>
        <label htmlFor="title">Author </label>
        <input
          type="text"
          name="author"
          value={blogDetails.author}
          onChange={handleChange}
          required
          className="border-2 border-rose-600"
        ></input>
        <button
          type="submit"
          className="bg-green-500 border-2 border-green-800 px-4"
        >
          Add blog
        </button>
      </div>
    </form>
  );
};

Form.propTypes = {};

export default Form;
